import axios from 'axios'

axios.defaults.xsrfCookieName = 'CSRF-TOKEN'
axios.defaults.xsrfHeaderName = 'X-CSRF-Token'
axios.defaults.withCredentials = true

const handleUnauthorized = (error: unknown) => {
  if (
    axios.isAxiosError(error) &&
    error.response &&
    error.response.status === 401
  ) {
    window.location.reload()
    return new Promise(() => null)
  }

  throw error
}

export const getRequest = async (url: string) => {
  try {
    return await axios.get(url).then((response) => response.data)
  } catch (error) {
    return handleUnauthorized(error)
  }
}

export const postRequest = async (url: string, data?: unknown) => {
  try {
    return await axios.post(url, data ?? {}).then((response) => response.data)
  } catch (error) {
    return handleUnauthorized(error)
  }
}

export const putRequest = async (url: string, data: unknown) => {
  try {
    return await axios.put(url, data).then((response) => response.data)
  } catch (error) {
    return handleUnauthorized(error)
  }
}

export const deleteRequest = async (url: string) => {
  try {
    return await axios.delete(url).then((response) => response.data)
  } catch (error) {
    return handleUnauthorized(error)
  }
}

export const postFormData = async (url: string, formData: FormData) => {
  try {
    return await axios
      .post(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((response) => response.data)
  } catch (error) {
    return handleUnauthorized(error)
  }
}

export const putFormData = async (url: string, formData: FormData) => {
  try {
    return await axios
      .put(url, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      .then((response) => response.data)
  } catch (error) {
    return handleUnauthorized(error)
  }
}
